module.exports = __webpack_public_path__ + "img/video_fmt.427e531f.jpg";